// services

import AxiosInstanceCreator from 'services/api';

// models
import type {
  ReqAddRiskAssessmentSettingApprovalLine,
  ReqAddUserRiskAssessmentSettingApprovalLine,
  ReqApprovalLineBatch,
  ReqDeleteUserRiskAssessmentSettingApprovalLine,
  ReqEditRiskAssessmentSettingApprovalLine,
  ReqRiskAssessmentSettingApprovalLineDetail,
  ResRiskAssessmentSettingApprovalLine,
  ResRiskAssessmentSettingApprovalLineDetail
} from '../models';
import type { CommonSearchProps } from 'modules/common';

const riskAssessmentInstance = new AxiosInstanceCreator({
  baseURL: `/v1/api/risk-assessment`
}).create();

export const riskAssessmentApi = {
  /**
   * 위험 평가 설정 결재라인 조회
   * @param {CommonSearchProps} params
   * @returns
   */
  async getRiskAssessmentSettingApprovalLine(
    params: CommonSearchProps
  ): Promise<ResRiskAssessmentSettingApprovalLine> {
    return await riskAssessmentInstance
      .get(`/setting/approval-line`, { params })
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재라인 상세 조회
   * @param {ReqRiskAssessmentSettingApprovalLineDetail} params
   * @returns
   */
  async getRiskAssessmentSettingApprovalLineDetail(
    params: ReqRiskAssessmentSettingApprovalLineDetail
  ): Promise<ResRiskAssessmentSettingApprovalLineDetail> {
    return await riskAssessmentInstance
      .get(`/setting/approval-line/${params.riskApprovalLineSettingId}`, { params })
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재자 생성
   * @param {ReqAddUserRiskAssessmentSettingApprovalLine} data
   * @returns
   */
  async addUserRiskAssessmentSettingApprovalLine(
    data: ReqAddUserRiskAssessmentSettingApprovalLine
  ) {
    return await riskAssessmentInstance
      .post(`/setting/approval-line/${data.riskApprovalLineSettingId}`, data)
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재라인 결재자 일괄 생성
   * @param {string} riskApprovalLineSettingId
   * @param {ReqApprovalLineBatch} data
   * @returns
   */
  async addUserApprovalLine(riskApprovalLineSettingId: string, data: ReqApprovalLineBatch) {
    return await riskAssessmentInstance
      .post(`/setting/approval-line/${riskApprovalLineSettingId}/batch`, data)
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재라인 생성
   * @param {ReqAddRiskAssessmentSettingApprovalLine} data
   * @returns
   */
  async addRiskAssessmentSettingApprovalLine(data: ReqAddRiskAssessmentSettingApprovalLine) {
    return await riskAssessmentInstance
      .post(`/setting/approval-line`, data)
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 수정
   * @param {ReqEditRiskAssessmentSettingApprovalLine} data
   * @returns
   */
  async updateRiskAssessmentSettingApprovalLine(data: ReqEditRiskAssessmentSettingApprovalLine) {
    return await riskAssessmentInstance
      .put(`/setting/approval-line/${data.riskApprovalLineSettingId}`, data)
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재라인 삭제
   * @param {string} riskApprovalLineSettingId
   * @returns
   */
  async deleteRiskAssessmentSettingApprovalLine(riskApprovalLineSettingId: string) {
    return await riskAssessmentInstance
      .delete(`/setting/approval-line/${riskApprovalLineSettingId}`)
      .then((res) => res.data);
  },

  /**
   * 위험 평가 설정 결재자 삭제
   * @param {ReqDeleteUserRiskAssessmentSettingApprovalLine} data
   * @returns
   */
  async deleteUserRiskAssessmentSettingApprovalLine(
    data: ReqDeleteUserRiskAssessmentSettingApprovalLine
  ) {
    return await riskAssessmentInstance
      .delete(`/setting/approval-line/${data.riskApprovalLineSettingId}/${data.userId}`)
      .then((res) => res.data);
  }
};
